var map = {
	"./angel-face.svg": 23808,
	"./cake.svg": 81399,
	"./heart-face.svg": 62149,
	"./heart.svg": 96229,
	"./laugh-17.svg": 7995,
	"./malicious.svg": 84059,
	"./party-popper.svg": 46360,
	"./smile.svg": 60921,
	"./thumb-up.svg": 89705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20083;